export default {
  /**
   * Fetch all enteries from skill table
   */
  async fetchAllJobTitles ({ commit }) {
    try {
      const response = await this._vm.$network_utils.getAllJobTitles()
      commit('setJobTitlesList', response)
    } catch (e) {
      console.error(e)
    }
  }
}
